import React from "react";
import { Box, Button, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
// unused imports removed
import Header from "../../../components/Header";
import Swal from "sweetalert2";
import { generateAndExecuteMutation } from "../../../data/Axios/DynamicService";
import { setupManagementUrl } from "../../../config";
const base_url = setupManagementUrl.uri;
const PaymentMethodForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);

  const initialValues = {
    methodName: props.data ? props.data.methodName : "",
  };

  const validationSchema = yup.object().shape({
    methodName: yup.string().required("Method Name is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const mutationData = {
        methodName: values.methodName,
      };

      if (props.isEditing) {
        mutationData.id = props.data.id;
        mutationData.updatedBy = userId;
        mutationData.createdBy = props.data.createdBy;
      } else {
        mutationData.createdBy = userId;
      }
      const response = await generateAndExecuteMutation(
        props.isEditing ? "updatePaymentMethods" : "createPaymentMethods",
        mutationData,
        "paymentmethods",
        base_url
      );
      if (response) {
        props.onClose();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Method ${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        }).then(() => {
          props.refetchData(); // Close the modal after the success message
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  return (
    <Box
      m="20px"
      bgcolor="background.paper"
      p={3}
      // borderRadius={8}
      // boxShadow={3}
    >
      <Header
        title={props.isEditing ? "Edit method" : "Create method"}
        subtitle={
          props.isEditing ? "Edit an Existing method" : "Create a New method"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px">
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Method Name *"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.methodName}
                name="methodName"
                error={touched.methodName && !!errors.methodName}
                helperText={touched.methodName && errors.methodName}
              />

              <Button
                type="submit"
                color="secondary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default PaymentMethodForm;
